<div class="row">
    <div class="col-12 pl-4">
        <yt-fw-default-update-buttons #defaultUpdateButtons>          
           
            <div class="mr-2"> 
                <h2 style="display:inline-block; color: #71b1d1">
                    <span *ngIf="baseUpdate.Item.ID <= 0"><span translate="COMPANYZRC.NEW.ZRC"></span></span>
                    <span *ngIf="baseUpdate.Item.ID > 0">
                        <span ><span translate="COMPANYZRC.EDIT.ZRC"></span></span>
                         
                    </span>
                </h2>
               
            </div>
           
      
            
        </yt-fw-default-update-buttons>


    </div>

</div>
<yt-company-zrc-new-update 
    #baseUpdate 
    [ModelData]="_modelData"
    [ParentPropertyName]="_parentPropertyName" 
    [ParentPropertyValue]="_parentPropertyValue"   
></yt-company-zrc-new-update>
